// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3im6W","newExpiryDate":"styles_newExpiryDate__1UP-g","footer":"styles_footer__2K4EQ"};